export interface BettingLimitState {
	activeBettingLimit?: BettingLimit;
	queuedBettingLimit?: BettingLimit;
	bettingLimits?: BettingLimit[];
	remainingBetLimits?: BettingLimit[];
}

export interface NetlossLimitState {
	activeNetlossLimit?: BettingLimit;
	queuedNetlossLimit?: BettingLimit;
	bettingLimits?: BettingLimit[];
}

export interface BettingLimit {
	limitValue: number;
	limitPeriod?: string;
	startDate: string;
	endDate: string;
	createdDate: string;
	status: BettingLimitStatus;
	type: BettingLimitType;
	productCategories?: string[];
	progressValue?: number;
	remainingValue?: number;
	limitType?: string;
}

export interface NetLossLimit {
	limitId: string | undefined;
	createdDate?: string;
	limitPeriod: string | undefined;
	limitValue: number;
	limitType: BettingLimitType | undefined;
	startDate?: string;
	endDate?: string;
	period: number;
	status: string | undefined;
}

export interface NetLossLimitConfirmation {
	status: NetLossLimitConfirmationStatus;
}

export interface BettingLimitParams {
	limitValue: number;
}

export interface TimedBettingLimitParams extends BettingLimitParams {
	period: string;
	productCategories?: string[];
}

export interface WageringLimitParams {
	amount: number;
}

export const enum LimitPeriod {
	Daily = "Daily",
	Weekly = "Weekly",
	Monthly = "Monthly",
}

export enum BettingLimitType {
	BetCountLimit = "BetCountLimit",
	WageringLimit = "WageringLimit",
	TimedWageringLimit = "TimedWageringLimit",
	NetlossLimit = "NetlossLimit",
	BetSizeLimit = "BetSizeLimit",
}

export const enum BettingLimitMessageCodes {
	UpdateBetCountLimitSuccess = "M_DEPOSIT_LIMIT_UPDATE_BET_COUNT_LIMIT_SUCCESS",
	UpdateWageringLimitSuccess = "M_DEPOSIT_LIMIT_UPDATE_WAGERING_LIMIT_SUCCESS",
	UpdateTimedWageringLimitSuccess = "M_DEPOSIT_LIMIT_UPDATE_TIMED_WAGERING_LIMIT_SUCCESS",
	UpdateNetlossLimitSuccess = "M_DEPOSIT_LIMIT_UPDATE_NETLOSS_LIMIT_SUCCESS",
	DeleteWageringLimitSuccess = "M_DEPOSIT_LIMIT_DELETE_WAGERING_LIMIT_SUCCESS",
	DeleteTimedWageringLimitSuccess = "M_DEPOSIT_LIMIT_DELETE_TIMED_WAGERING_LIMIT_SUCCESS",
	DeleteTimedWageringLimitWithPayloadSuccess = "M_DEPOSIT_LIMIT_DELETE_TIMED_WAGERING_LIMIT_WITH_PAYLOAD_SUCCESS",
	DeleteBetCountLimitSuccess = "M_DEPOSIT_LIMIT_DELETE_BET_COUNT_LIMIT_SUCCESS",
	DeleteNetlossLimitSuccess = "M_DEPOSIT_LIMIT_DELETE_NETLOSS_LIMIT_SUCCESS",
	DeleteNetlossLimitWithPayloadSuccess = "M_DEPOSIT_LIMIT_DELETE_NETLOSS_LIMIT_WITH_PAYLOAD_SUCCESS",
}

export const enum BettingLimitStatus {
	Active = "Active",
	Used = "Used",
	Queued = "Queued",
	Cancelled = "Cancelled",
	WaitingForConfirmation = "WaitingForConfirmation",
	All = "All",
}

export enum NetLossLimitConfirmationStatus {
	Active = "Active",
	Cancelled = "Cancelled",
}

export interface BettingLimitConfig {
	isDeleteLimitEnabled: boolean;
}
export interface BettingLimitContent {
	currentLimit: string;
	limitNone: string;
	title: string;
	buttonEdit: string;
	buttonDelete: string;
	editTitle: string;
	inputLabel: string;
	buttonCancel: string;
	buttonSave: string;
	caption: string;
}

export enum Prefix {
	BettingLimit = "betting-limit",
}

export interface BettingLimitPeriod {
	value: string;
	label: string;
	isChecked?: boolean;
}

export interface BettingLimitQueued {
	data: BettingLimit | undefined;
	limitInfo: string;
}

export interface BettingLimitForm {
	limit: {
		isRequired?: boolean;
		maxLength?: number;
		value?: number;
	};
	limitType: BettingLimitType | undefined;
	period?: LimitPeriod | undefined;
}

export interface BettingLimitActive extends BettingLimit {
	cashAmount: string;
}

export interface BettingLimitMfe {
	data: BettingLimit | undefined;
	limitInfo: string | undefined;
}

export interface BettingActiveLimit extends BettingLimitMfe {
	cashAmount: string | undefined;
}
export interface BettingLimitSubmission {
	amount: number;
	period: LimitPeriod | BettingLimitType;
}
